import React, { useState, memo } from "react";
import { Flex, Heading, Text } from "@edricphan2022/uikit";
import { BannerInfomation } from "./style";

// config
import { ArrInfroBanner } from "./config";

const InfomationBanner: React.FC = () => {
  const [isArrBannerInfo] = useState(ArrInfroBanner);
  return (
    <BannerInfomation>
      {isArrBannerInfo.map((_item, _index) => (
        <Flex
          key={`infobaner ${_index}`}
          flexDirection="column"
          alignItems="flex-start"
        >
          <h1>
            {_item.number}
          </h1>
          <p>
            {_item.title}
          </p>
        </Flex>
      ))}
    </BannerInfomation>
  );
};

export default memo(InfomationBanner);
